import { Pipe, PipeTransform } from '@angular/core';

export function customDateTransform(value: any): Date {
  return new Date(value.match(/\d+/)[0] * 1);
}

/*
 * https://www.codementor.io/@niladrisekhardutta/how-to-convert-date-format-from-date-xxxxxxxxxx-to-custom-format-in-angular-2-wedb5n928
 * Formats a /Date(xxxxxxxxxxxxx)/ into a JSON Date object
 * Takes an argument as input of actual date value in /Date(xxxxxxxxxxxxx)/ format.
 * Usage:
 *   date-value | customDateFormat
 * Example:
 *   {{ '/Date(1402034400000)/' | customDateFormat}}
 */
@Pipe({ name: 'customDateFormat' })
export class CustomDateFormatPipe implements PipeTransform {
  transform(value: any): Date {
    if (value === undefined || value === null) {
      return null; // or any other default value based on your requirement
    }
    return customDateTransform(value);
  }
}
